export default __webpack_public_path__ + "static/media/Anna Maria Giordano.6c4d1902.jpg";